var createSyntheticEvent = function createSyntheticEvent(target, event) {
  var _isDefaultPrevented = false;
  var _isPropagationStopped = false;
  var preventDefault = function preventDefault() {
    _isDefaultPrevented = true;
    event.preventDefault();
  };
  var stopPropagation = function stopPropagation() {
    _isPropagationStopped = true;
    event.stopPropagation();
  };
  return {
    nativeEvent: event,
    currentTarget: target,
    target: target,
    bubbles: event.bubbles,
    cancelable: event.cancelable,
    defaultPrevented: event.defaultPrevented,
    eventPhase: event.eventPhase,
    isTrusted: event.isTrusted,
    preventDefault: preventDefault,
    isDefaultPrevented: function isDefaultPrevented() {
      return _isDefaultPrevented;
    },
    stopPropagation: stopPropagation,
    isPropagationStopped: function isPropagationStopped() {
      return _isPropagationStopped;
    },
    persist: function persist() {},
    timeStamp: event.timeStamp,
    type: event.type
  };
};

export { createSyntheticEvent };
//# sourceMappingURL=eventHelpers.js.map
